<template>
  <div class="main tabs_main" style="height:89%">
    <div class="main_header">
      <div class="header_item">
        <span class="header_label">时间范围：</span>
        <el-date-picker
            v-model="search.time"
            type="daterange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00','23:59:59']"
            range-separator="-"
            start-placeholder="起始时间"
            end-placeholder="结束时间">
        </el-date-picker>
      </div>
      <div class="header_item">
        <el-button   :size="size" icon="el-icon-search" v-if="showButton('search')" @click="searchButtonInfo(true)">查询</el-button>
      </div>
    </div>
    <div class="main_content">
      <el-table
        v-loading="loading"
        :data="dataList"
        height="100%">
        <el-table-column align="center" label="序号" width="60">
          <template #default="scope">
            <span>{{(pageNum - 1) * pageSize + scope.$index + 1}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="code" label="入库单编号" align="center"></el-table-column>
        <el-table-column prop="supplierName" label="供应商名称" align="center" ></el-table-column>
        <el-table-column prop="weighGrossTim" label="过毛时间" align="center" ></el-table-column>
        <el-table-column prop="weighTareTim" label="过皮时间" align="center" ></el-table-column>
        <el-table-column prop="weighSuttle" label="过磅净重（千克）" align="center" ></el-table-column>
        <el-table-column prop="suttle" label="净重" align="center" ></el-table-column>
        <el-table-column prop="meteringVolume" label="计量数量" align="center" ></el-table-column>
        <el-table-column prop="oreNum" label="来料数量" align="center" ></el-table-column>
        <el-table-column prop="gross" label="毛重" align="center" ></el-table-column>
        <el-table-column prop="secret" label="实际总暗扣重量（千克）" align="center" ></el-table-column>
        <el-table-column prop="settleName" label="结算时的原材料名称" align="center" ></el-table-column>
        <el-table-column prop="settleMode" label="结算时的原材料规格型号" align="center" ></el-table-column>
        <el-table-column prop="vehicleCode" label="车牌号" align="center" ></el-table-column>
        <el-table-column prop="driverMan" label="司机" align="center" ></el-table-column>
        <el-table-column prop="materialName" label="原材料" align="center" ></el-table-column>
        <el-table-column prop="storhouseName" label="储料仓" align="center" ></el-table-column>
        <el-table-column prop="specification" label="原材料规格" align="center" ></el-table-column>
        <el-table-column prop="categoryName" label="入库类别名称" align="center" ></el-table-column>
        <el-table-column prop="storhouseName" label="储料仓名称" align="center" ></el-table-column>
        <el-table-column prop="storemanName" label="库管人员名称" align="center" ></el-table-column>
        <el-table-column prop="type" label="原材料类别" align="center" >
            <template #default="{row}">
                <div>{{optionMatType[row.type]&&optionMatType[row.type].label}}</div>
            </template>
        </el-table-column>
        <el-table-column prop="typeName" label="原材料类型名称" align="center" ></el-table-column>
        <el-table-column prop="weighGross" label="过磅毛重" align="center" ></el-table-column>
        <el-table-column prop="weighTare" label="过磅皮重" align="center" ></el-table-column>
        <el-table-column prop="moiSture" label="含水率" align="center" ></el-table-column>
        <el-table-column prop="amount" label="入库数量" align="center" ></el-table-column>
        <el-table-column prop="stockPre" label="入库前库存" align="center" ></el-table-column>
        <el-table-column prop="stockAfter" label="入库后库存" align="center" ></el-table-column>
        <el-table-column prop="state" label="入库单状态" align="center" >
            <template #default="{row}">
                <div>{{optionState[row.state]&&optionState[row.state].label}}</div>
            </template>
        </el-table-column>
        <el-table-column prop="inState" label="入仓状态" align="center" >
            <template #default="{row}">
                <div>{{optionInstate[row.inState]&&optionInstate[row.inState].label}}</div>
            </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="main_footer">
      <el-pagination
        background
        @current-change="changePageNum"
        @size-change="changePageSize"
        :current-page="pageNum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { buttonPinia } from '../../../pinia/index';
import { changeSize } from '../../../plugins/public'; // 导入节流、动态切换组件尺寸方法
  export default {
    data() {
      return {
        size: changeSize(), // 组件尺寸
        pageNum: 1,
        pageSize: 10,
        search:{},//查询条件
        total: 0,
        loading: false,
        dataList: [], //生产线料仓库存列表
        optionInstate:[{//入仓状态
            label:'未确认入仓',
            value:0
        },{
            label:'等待入仓',
            value:1
        },{
            label:'确认入仓',
            value:2
        }],
        optionState:[{//入库单状态
            label:'已过毛',
            value:1
        },{
            label:'已入仓',
            value:2
        },{
            label:'已过皮',
            value:3
        },{
            label:'已完成',
            value:4
        }],
        optionMatType:[{//原材料类别
            label:'粗骨料',
            value:"1"
        },{
            label:'细骨料',
            value:"2"
        },{
            label:'水泥',
            value:"3"
        },{
            label:'粉煤灰',
            value:"4"
        },{
            label:'矿粉',
            value:"5"
        },{
            label:'外加剂',
            value:"6"
        },{
            label:'水',
            value:"7"
        },{
          label:'纤维',
          value:"8"
        }],
      }
    },
    mounted() {
      const that = this;
      // 根据窗口大小动态修改组件尺寸
      window.onresize = () => {
        that.size = changeSize();
      }
    },
    methods: {
      // 查询按钮列表信息
      searchButtonInfo(bol) {
        if(bol) {
          this.pageNum = 1;
        }
        let params = Object.assign({},this.search,{
          pageNum: this.pageNum,
          pageSize: this.pageSize,
        })
        params.startTime = this.search.time&&this.search.time[0]
        params.endTime = this.search.time&&this.search.time[1]
        delete params.time
        this.loading = true;
        this.$api.Materials.searchTodayQualityList(params).then((res) => {
          if(res.statusMsg === 'ok') {
            this.total = res.data.total;
            this.dataList = res.data.list;
          }
          this.loading = false;
        })
      },
      // 判断按钮权限信息
      showButton(str) {
        const pinia = buttonPinia();
        return pinia.$state.buttonInfo.includes(str);
      },      
      // 切换页数
      changePageNum(page) {
        this.pageNum = page;
        this.searchButtonInfo();
      },
      // 切换每页条数
      changePageSize(size) {
        this.pageSize = size;
        this.searchButtonInfo();
      }
    }
  }
</script>

<style lang="scss" scoped>
@import'@/style/layout-main.scss';
</style>